import React from 'react'
import styled from 'styled-components'
import { IconTruck } from '../Icons'
import { Typography } from '../Typography'
import { Copy } from '../Copy'

export const DeliveryText = ({
  children,
  isCentered = false,
}: {
  children: any
  isCentered?: boolean
}) => {
  return (
    <Container isCentered={isCentered}>
      <IconTruck width={35} height="auto" />
      <Label>
        {typeof children === 'string' ? <Copy html={children} /> : children}
      </Label>
    </Container>
  )
}
const Container = styled.div.attrs({
  className: 'd-flex align-items-center p-3',
})<{ isCentered?: boolean }>`
  font-size: 1.6rem;
  background-color: ${({ theme }) => theme.palette.yellow};
  color: ${({ theme }) => theme.palette.dark};

  & span {
    color: inherit !important;
  }

  ${({ isCentered }) =>
    isCentered &&
    `
    justify-content: center;
  `}
`

const Label = styled(Typography).attrs({
  as: 'p',
})`
  margin-left: 1rem;
`
